module.exports = __webpack_public_path__ + "static/jyb-34f792d98efb0b39fba5390b796dcc6f.jpeg";